import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { EBaseUrl } from "../models/enums/env.enum";
import { api } from "../utils";

const initialState: any = {
  postCardsData: [],
  giftCardsData: [],
  templateLettersData: [],
  templateEnvelopesData: [],
  textTemplates: [],
  countries: [],
  mobileCodes: [],
  selectedCardIDs: null,
};

const name = "Template";

export const getPostCards = createAsyncThunk(
  `${name}/getPostCards`,
  async () => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/${name}/PostCards`,
    });
  }
);

export const getGiftCards = createAsyncThunk(
  `${name}/getGiftCards`,
  async () => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/${name}/Cards`,
    });
  }
);

export const getEnvelopes = createAsyncThunk(
  `${name}/getEnvelopes`,
  async () => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/${name}/Envelopes`,
    });
  }
);

export const getLetters = createAsyncThunk(`${name}/getLetters`, async () => {
  return api({
    method: "GET",
    url: `${EBaseUrl.envLetter}/${name}/Letters`,
  });
});

export const getTextTemplates = createAsyncThunk(
  `${name}/getTextTemplates`,
  async () => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/${name}/Text`,
    });
  }
);

export const getCountries = createAsyncThunk(
  `${name}/getCountries`,
  async () => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/${name}/Countries`,
    });
  }
);

export const getMobileCodes = createAsyncThunk(
  `${name}/getMobileCodes`,
  async () => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/${name}/MobileCodes`,
    });
  }
);

const templateSlice = createSlice({
  name,
  initialState,
  reducers: {
    updatePostCardList(state, { payload }) {
      state.postCardsData = payload;
    },
    updateGiftCardList(state, { payload }) {
      state.giftCardsData = payload;
    },
    updateSelectedCardsList(state, { payload }) {
      state.selectedCardIDs = payload;
    },
    updateLetterTemplatesList(state, { payload }) {
      state.templateLettersData = payload;
    },
    updateEnvelopeTemplatesList(state, { payload }) {
      state.templateEnvelopesData = payload;
    },
    updateTextTemplatesList(state, { payload }) {
      state.textTemplates = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPostCards.fulfilled, (state, { payload }) => {
      state.postCardsData = payload;
    });
    builder.addCase(getGiftCards.fulfilled, (state, { payload }) => {
      state.giftCardsData = payload;
    });
    builder.addCase(getEnvelopes.fulfilled, (state, { payload }) => {
      state.templateEnvelopesData = payload;
    });
    builder.addCase(getLetters.fulfilled, (state, { payload }) => {
      state.templateLettersData = payload;
    });
    builder.addCase(getTextTemplates.fulfilled, (state, { payload }) => {
      state.textTemplates = payload;
    });
    builder.addCase(getCountries.fulfilled, (state, { payload }) => {
      state.countries = payload;
    });
    builder.addCase(getMobileCodes.fulfilled, (state, { payload }) => {
      state.mobileCodes = payload;
    });
  },
});

export const selectLetters = (state: any) => state.template.templateLettersData;

export const selectEnvelopes = (state: any) =>
  state.template.templateEnvelopesData;

export const selectGiftCards = (state: any) => state.template.giftCardsData;

export const selectPostCards = (state: any) => state.template.postCardsData;

export const selectTextTemplates = (state: any) => state.template.textTemplates;

export const selectCountries = (state: any) => state.template.countries;

export const selectMobileCodes = (state: any) => state.template.mobileCodes;
export const selectChosenCardIDs = (state: any) =>
  state.template.selectedCardIDs;

export const {
  updatePostCardList,
  updateGiftCardList,
  updateEnvelopeTemplatesList,
  updateLetterTemplatesList,
  updateTextTemplatesList,
  updateSelectedCardsList,
} = templateSlice.actions;

export default templateSlice.reducer;
